export enum UserType {
    School = 'school',
    Guest = 'guest',
    Student = 'student',
    Admin = 'admin',
}